import { createFileRoute, notFound } from '@tanstack/react-router'
import { DeviceNotFound } from '../../components/errors/NotFound.tsx'
import { deviceListQuery } from '../../data/devices.ts'
import { MeasurementGraphView } from '../../features/measurements/graph/MeasurementGraphView.tsx'

export const Route = createFileRoute('/_app/measurements/$id')({
	component: MeasurementGraphView,
	notFoundComponent: () => <DeviceNotFound redirectTo='/measurements' />,
	loader: async ({ context: { queryClient, impersonation }, params }) => {
		const devices = await queryClient.ensureQueryData(deviceListQuery(impersonation?.partyAccountId))
		if (!devices.some((device) => device.id === params.id)) {
			throw notFound()
		}
	},
})
